import React, { useMemo, useState } from "react";
import "./date-picker.m.css";
import CalenderArrow from "../../../atoms/other-icons/calender-arrow";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

const DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export default function BirthDatePicker({
  isOpen,
  onClose,
  birthDate,
  setBirthDate
}) {
  const today = new Date();
  const [viewMonth, setViewMonth] = useState(
    birthDate ? birthDate.getMonth() : today.getMonth()
  );

  const [viewYear, setViewYear] = useState(
    birthDate ? birthDate.getFullYear() : today.getFullYear()
  );

  const years = [];

  for (let y = today.getFullYear(); y >= 1900; y--) {
    years.push(y);
  }

  const calendarDays = useMemo(() => {
    const firstDay = new Date(viewYear, viewMonth, 1);

    const startDay = firstDay.getDay();

    const daysInMonth = new Date(
      viewYear,
      viewMonth + 1,
      0
    ).getDate();

    const prevMonthDays = new Date(
      viewYear,
      viewMonth,
      0
    ).getDate();

    const days = [];

    for (let i = startDay - 1; i >= 0; i--) {
      days.push({
        day: prevMonthDays - i,
        muted: true,
        current: false
      });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      days.push({
        day: i,
        muted: false,
        current: true
      });
    }

    const totalCells = Math.ceil((startDay + daysInMonth) / 7) * 7;

    while (days.length < totalCells) {
      days.push({
        day: days.length - (startDay + daysInMonth) + 1,
        muted: true,
        current: false
      });
    }

    return days;
  }, [viewMonth, viewYear]);

  if (!isOpen) return null;

  const previousMonth = () => {
    if (viewMonth === 0) {
      setViewMonth(11);
      setViewYear(viewYear - 1);
    } else {
      setViewMonth(viewMonth - 1);
    }
  };

  const nextMonth = () => {
    if (viewMonth === 11) {
      setViewMonth(0);
      setViewYear(viewYear + 1);
    } else {
      setViewMonth(viewMonth + 1);
    }
  };

  return (
    <div
      styleName="calendar-overlay"
      onClick={onClose}
    >
      <div
        styleName="calendar-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div styleName="calendar-header">

          <button onClick={previousMonth}>
            <CalenderArrow />
          </button>
          <div styleName="select-wrapper">
            <select
              value={viewMonth}
              onChange={(e) =>
                setViewMonth(Number(e.target.value))
              }
            >
              {MONTHS.map((month, index) => (
                <option
                  key={month}
                  value={index}
                >
                  {month}
                </option>
              ))}
            </select>
            <span styleName="select-arrow">
              <CalenderArrow />
            </span>
          </div>

          <div styleName="select-wrapper">
            <select
              value={viewYear}
              onChange={(e) =>
                setViewYear(Number(e.target.value))
              }
            >
              {years.map((year) => (
                <option
                  key={year}
                  value={year}
                >
                  {year}
                </option>
              ))}
            </select>
            <span styleName="select-arrow">
              <CalenderArrow />
            </span>
          </div>
          <button onClick={nextMonth} style={{transform: "rotate(-180deg)"}}>
            <CalenderArrow />
          </button>

        </div>

        <div styleName="weekday-row">
          {DAYS.map((day) => (
            <div key={day}>
              {day}
            </div>
          ))}
        </div>

        <div styleName="calendar-grid">
          {calendarDays.map((cell, index) => {
            const isToday =
              cell.current &&
              today.getDate() === cell.day &&
              today.getMonth() === viewMonth &&
              today.getFullYear() === viewYear;

            const selected = birthDate
              ? (cell.current &&
                 birthDate.getDate() === cell.day &&
                 birthDate.getMonth() === viewMonth &&
                 birthDate.getFullYear() === viewYear)
              : isToday;

            return (
              <button
                key={index}
                styleName={`day-cell ${cell.muted ? "muted" : ""} ${selected ? "selected" : ""}`}
                onClick={() => {
                  if (!cell.current) return;
                  setBirthDate(
                    new Date(
                      viewYear,
                      viewMonth,
                      cell.day
                    )
                  );

                  onClose();
                }}
              >
                {cell.day}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
